module.exports = __webpack_public_path__ + "img/kj_ico3.6f3ce87a.png";